var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.$store.getters.token
    ? _c("login")
    : _vm.isRouteReady
    ? _c(
        "div",
        {
          class: [
            _vm.$store.getters.sidebar.opened ? "" : "miniMenu2",
            "wrapper",
            "menuFixed",
          ],
          attrs: { id: "mainWrapper" },
        },
        [
          !_vm.showFullLayout
            ? [
                _c(
                  "div",
                  { attrs: { id: "content" } },
                  [
                    _c("router-view", {
                      key: _vm.$route.fullPath,
                      attrs: { id: "data" },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c("sidebar", { ref: "menu" }),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "content" } },
                  [
                    _c("mainbar"),
                    _vm._v(" "),
                    _c("history-menu"),
                    _vm._v(" "),
                    _c("router-view", {
                      key: _vm.$route.fullPath,
                      attrs: { id: "data" },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _c(
        "div",
        {
          staticClass: "loading",
          staticStyle: { height: "100vh", width: "100vw" },
        },
        [_vm._v("\n   \n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }